// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Stylex from "@stylexjs/stylex";
import * as JsxRuntime from "react/jsx-runtime";
function styleProps(hovered, size) {
  return {
    0: {
      className: "color-x10zwbdr whiteSpace-xuxw1ft backgroundColor-xx95sbj borderColor-x9lnrua borderRadius-x1cum3z5 borderStyle-x1y0btm7 borderWidth-xmkeg23 alignItems-x6s0dn4 display-x3nfvp2 font-xyj1cuj lineHeight-x1jlp1m6 padding-x1nyoefi",
      "data-style-src": "wino-gc:src/resources/typography/Kbd.res.js:8; wino-gc:src/resources/typography/Kbd.res.js:24"
    },
    2: {
      className: "color-x10zwbdr whiteSpace-xuxw1ft backgroundColor-xx95sbj borderColor-x9lnrua borderRadius-x1cum3z5 borderStyle-x1y0btm7 borderWidth-xmkeg23 alignItems-x6s0dn4 display-x3nfvp2 font-xhhohpu lineHeight-x152skdk padding-x1dumkz1",
      "data-style-src": "wino-gc:src/resources/typography/Kbd.res.js:8; wino-gc:src/resources/typography/Kbd.res.js:19"
    },
    1: {
      className: "color-x10zwbdr whiteSpace-xuxw1ft backgroundColor-xx95sbj borderColor-x9lnrua borderRadius-x1cum3z5 borderStyle-x1y0btm7 borderWidth-xmkeg23 alignItems-x6s0dn4 display-x3nfvp2 font-xyj1cuj lineHeight-x1jlp1m6 padding-x1nyoefi",
      style: {
        borderColor: "#535165"
      },
      "data-style-src": "wino-gc:src/resources/typography/Kbd.res.js:8; wino-gc:src/resources/typography/Kbd.res.js:24"
    },
    3: {
      className: "color-x10zwbdr whiteSpace-xuxw1ft backgroundColor-xx95sbj borderColor-x9lnrua borderRadius-x1cum3z5 borderStyle-x1y0btm7 borderWidth-xmkeg23 alignItems-x6s0dn4 display-x3nfvp2 font-xhhohpu lineHeight-x152skdk padding-x1dumkz1",
      style: {
        borderColor: "#535165"
      },
      "data-style-src": "wino-gc:src/resources/typography/Kbd.res.js:8; wino-gc:src/resources/typography/Kbd.res.js:19"
    }
  }[!!(size === "normal") << 1 | !!hovered << 0];
}
function Kbd(props) {
  let __size = props.size;
  let __hovered = props.hovered;
  let hovered = __hovered !== undefined ? __hovered : false;
  let size = __size !== undefined ? __size : "normal";
  let match = styleProps(hovered, size);
  return JsxRuntime.jsx("kbd", {
    children: props.children,
    className: match.className,
    style: match.style
  });
}
let make = React.memo(Kbd);
export { make };
/* styles Not a pure module */